// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: <script type="text/javascript" src="https://api.feefo.com/api/javascript/thompson-and-holt" async></script>
});